// extracted by mini-css-extract-plugin
export default {"goBackButton":"GoBackButton_goBackButton__ejo6h","goBackButtonError":"GoBackButton_goBackButtonError__NU7aY"};